import { render, staticRenderFns } from "./protocol.vue?vue&type=template&id=3efb4893&scoped=true"
import script from "./protocol.vue?vue&type=script&lang=js"
export * from "./protocol.vue?vue&type=script&lang=js"
import style0 from "./protocol.vue?vue&type=style&index=0&id=3efb4893&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efb4893",
  null
  
)

export default component.exports